import React, { useContext } from 'react';
import Banner from './banner/Banner';
import Categories from './categories/Categories';
import PageContainer from '../../layouts/page-container/PageContainer';
import c from './home.module.scss';
import bean from './home-banner-background.svg';
import { SearchContext } from '../../providers/search-provider/SearchProvider';
import { FeatureContext } from '@monash/portal-frontend-common';

const Home = () => {
  const { allCategories, isLoadingCategories } = useContext(SearchContext);
  const { featureFlags } = useContext(FeatureContext);
  const areFlagsLoading = !Object.keys(featureFlags).length;

  if (isLoadingCategories || areFlagsLoading) {
    return null;
  }

  return (
    <PageContainer>
      <div className={c.home}>
        <img src={bean} alt="" className={c.blueBean} aria-hidden="true" />
        <div className={c.homeContent}>
          <div className={c.bannerContainer}>
            <Banner />
          </div>
          <div className={c.categoryContainer}>
            <Categories categories={allCategories} />
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default Home;
